const wayToPay = [
  { id: 1, name: '01 - Efectivo', code: '01' },
  { id: 2, name: '02 - Cheque Nominativo', code: '02' },
  { id: 3, name: '03 - Transferencia Electrónica De Fondos', code: '03' },
  { id: 4, name: '04 - Tarjeta De Crédito', code: '04' },
  { id: 5, name: '05 - Monedero Electrónico', code: '05' },
  { id: 6, name: '06 - Dinero Electrónico', code: '06' },
  { id: 7, name: '07 - Vales De Despensa', code: '07' },
  { id: 8, name: '12 - Dación en Pago', code: '12' },
  { id: 9, name: '13 - Pago por Subrogación', code: '13' },
  { id: 10, name: '14 - Pago por Consignación', code: '14' },
  { id: 11, name: '15 - Condonación', code: '15' },
  { id: 12, name: '17 - Compensación', code: '17' },
  { id: 13, name: '23 - Novación', code: '23' },
  { id: 14, name: '24 - Confusión', code: '24' },
  { id: 15, name: '25 - Remisión De Deuda', code: '25' },
  { id: 16, name: '26 - Prescripción o Caducidad', code: '26' },
  { id: 17, name: '27 - A Satisfacción del Acreedor', code: '27' },
  { id: 18, name: '28 - Tarjeta De Débito', code: '28' },
  { id: 19, name: '29 - Tarjeta De Servicios', code: '29' },
  { id: 20, name: '30 - Aplicación De Anticipos', code: '30' },
  { id: 21, name: '99 - Por Definir', code: '99' },
  { id: 22, name: 'N/A', code: 'NA' }
]

export default wayToPay
